module.exports = __webpack_public_path__ + "files/35cb3703f554b08d370ac2c2ca6f0689.png";